import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import {NumberFormat,DateThaiFormat,DateFormat,DateThai,GetRole} from '../../Utils/Function';
import { createRoot } from 'react-dom/client';
import {StoreInfoCard} from '../../Components/Store';
import Swal from 'sweetalert2';
import API from '../../API';
import "react-datepicker/dist/react-datepicker.css";
import '../../Assets/CSS/TALFC.css';

const PageStoreList =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();

    const ref = useRef();
    const _StoreInfoCard = useRef();
    const [GroupList,setGroupList] = useState([]);

    useEffect(() => {
        (async () => {

        })();

        return ()=>{ }
    }, []);

    const _configs = {
        "order": [[0, "desc"]],
        pageLength: 25,
        orderMulti: true
    }
    const _ajax  = {
        'url': '/Admin/Store/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            //d.Role = getValues('Role');
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
            <button type='button' title='รายละเอียด' className='btn btn-info text-white' onClick={() => _StoreInfoCard.current?.Show(d)}>Info</button>

        </div>
    )
    const _column = [
        { data: "StoreCode", name: "StoreCode", autoWidth: true },
        { data: "StoreName", name: "StoreName", autoWidth: true },
        { data: "Description", name: "Description", autoWidth: true },
        { data: "Gpshare", name: "GPShare", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "Status", name: "Status", autoWidth: true,render(data){
            switch(data){
                case 1 : return "เปิด";
                case 0 : return "ปิด";
                default : return "-";
            }
        } },  
        {data: "Updated", name: "Updated", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        {
            data: "StoreId", name: "StoreId", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    
    const _UpdateTable =()=>{
        ref.current?.load();
    }

    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-4'>
                    <div className='col-lg-12'>
                    <div className='card'>
                            <div className='card-header'>
                                <h3 className='card-title'>จัดการร้านค้า</h3>
                            </div>
                            <div className='card-body' style={{'minHeight':'300px'}}>
                            <div className='row d-flex justify-content-end'>
                                <div className='col-12 col-lg-1'>
                                    <div className='input-group'>
                                        <div className='btn btn-group '>
                                            <button type='button' className='btn btn-danger text-white' onClick={()=>{_StoreInfoCard.current?.Show(null);}}>เพิ่มร้านค้า</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                                <div className='row'>
                                    <div className="col-lg-12 table-responsive">
                                        <table id="UserTableView" className='table w-100' role='grid'>
                                            <thead>
                                                <tr>
                                                    <th className="text-center textcenter">รหัสร้านค้า</th>
                                                    <th className="text-center textcenter">ชื่อร้านค้า</th>
                                                    <th className="text-center textcenter">รายละเอียด</th>
                                                    <th className="text-center textcenter">เปอร์เซ็น</th>
                                                    <th className="text-center textcenter">สถานะ</th>
                                                    <th className="text-center textcenter">วันที่แก้ไข</th>
                                                    <th className="text-center no-sort"></th>
                                                </tr>
                                            </thead>
                                            <DataTable TableID={"UserTableView"} Column={_column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <StoreInfoCard ref={_StoreInfoCard}  update={()=>{ref.current?.load();}}/>
        </React.Fragment>
        </>
    )
}

export default React.memo(PageStoreList)
